import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './Tooltip.scss';
import { useMosaicContext } from '../../contexts/mosaicContext';

const TooltipBody = ({ children }) => {
  const isMosaicDesign = useMosaicContext();

  return (
    <div
      aria-live="off"
      className={clsx('flex flex-column', styles.tooltipBody)}
    >
      <div className={clsx('pad-lr pad-1-t', !isMosaicDesign && 'pad-b')}>
        {children}
      </div>
    </div>
  );
};

TooltipBody.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TooltipBody;
